import { useEffect } from 'react'

export const useScrollListener = (action: () => void): void => {
  useEffect(() => {
    const handleScroll = () => {
      action()
    }

    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
}
